// Copyright Epic Games, Inc. All Rights Reserved.
import {Locale} from '@common/hygraph-schema';

export const defaultLocale = 'en-US';

export const overrideLocales = {
	'es-419': 'es-MX',
	es: 'es-ES',
	en: 'en-US',
	'zh-HK': 'zh-Hant',
	'zh-TW': 'zh-Hant',
	'zh-Hans': 'zh-CN'
};

// prettier-ignore
export const locales = [
	"en-US", "ar", "bg", "cs", "da", "de", "fi", "fil", "es-ES", "es-MX", "fr",
	"hi", "hu", "id", "it", "ja", "ko", "ms", "nl", "no", "pl", "pt", "pt-BR", "ro", "ru",
	"sv", "th", "tr", "uk", "vi", "zh-CN", "zh-Hant",
];

// mapped from local locales to hygraph
export enum hygraphLocales {
	en_US = Locale.En,
	ar = Locale.Ar,
	bg = Locale.Bg,
	cs = Locale.Cs,
	da = Locale.Da,
	de = Locale.De,
	fi = Locale.Fi,
	fil = Locale.Fil,
	es_es = Locale.EsEs,
	es_mx = Locale.EsMx,
	fr = Locale.Fr,
	hi = Locale.Hi,
	hu = Locale.Hu,
	id = Locale.Id,
	it = Locale.It,
	ja = Locale.Ja,
	ko = Locale.Ko,
	ms = Locale.Ms,
	nl = Locale.Nl,
	no = Locale.No,
	pl = Locale.Pl,
	pt = Locale.Pt,
	pt_br = Locale.PtBr,
	ro = Locale.Ro,
	ru = Locale.Ru,
	sv = Locale.Sv,
	th = Locale.Th,
	tr = Locale.Tr,
	uk = Locale.Uk,
	vi = Locale.Vi,
	zh_cn = Locale.ZhCn,
	zh_hant = Locale.ZhHant
}

export const CJKLocales = ['zh-CN', 'zh-Hant', 'ko', 'ja']; // These locales have specific word wrapping rules

export const localeSet = new Set(locales.map((l) => l.toLowerCase()));

export const i18n = {
	defaultLocale,
	locales,
	hygraphLocales,
	localeSet
};
